export const HOTJAR_SUPPRESS_ATTRS = { 'data-hj-suppress': true };
